export const IOS_APP_STORE_URL = 'https://apps.apple.com/de/app/make-it-booking/id6791606431';
